import $http from "@/plugins/axios";
import utils from "@/services/utils";

const CustomerService = {
    getAllCustomerNotes (botCode, customerId) {
        return $http.get("/live-support/" + botCode + "/customer-note/" + customerId + "/");
    },
    createCustomerNote (botCode, customerId, note) {
        return $http.post(
            `/live-support/${botCode}/customer-note/${customerId}/`,
            {
                "note": note
            }
        )
    },
    updateCustomerNote (botCode, customerId, note_id, note) {
        return $http.put(
            `/live-support/${botCode}/customer-note/${customerId}/${note_id}/`,
            {
                "note": note
            }
        )
    },
    deleteCustomerNote (botCode, customerId, note_id) {
        return $http.delete(
            `/live-support/${botCode}/customer-note/${customerId}/${note_id}/`
        )
    },
    sendStatusSeenCustomerMessage (botCode, customerId) {
        $http.post("/live-support/update-seen-status/" + botCode + "/" + customerId + "/", { "seen": true })
    },
    getCustomers(bot_code, channel, search, agent_email, search_type='user', type, skills, is_long_wait, advance_filter, fromDate, toDate,page, page_size=50) {
        let query = utils.buildQuery(channel, search, agent_email, search_type, type, skills, is_long_wait,advance_filter, fromDate, toDate, page,page_size);
        return $http.get(`/live-support/list-customers/${bot_code}?${query}`);
    },
    getCustomersCount(bot_code) {
        return $http.get(`/live-support/customers-count/${bot_code}`)
    },
    getCrmCustomers(bot_code, properties, projection, page, page_size=50, fromDate, toDate) {
        let query = utils.buildCrmQuery(properties, projection, page, page_size);
        return $http.post(`/live-support/filter-crm-customers/${bot_code}/${fromDate}/${toDate}?${query}`, {"properties":properties});
    },
    getCustomerAttributes(bot_code, sender_id) {
        return $http.get("/live-support/" + bot_code + "/get-customer-attributes/" + sender_id + "/");
    },
    getCustomerOverview(botCode, channels, from, to) {
        return $http.get(`/live-support/customer-overview/${botCode}?channels=${channels}&from=${from}&to=${to}`)
    },
    updateCustomerAttributes(bot_code, sender_id, sender_attribute) {
        return $http.post("/live-support/" + bot_code + "/update-customer-attribute/" + sender_id + "/", sender_attribute);
    },
    getCustomerExtraFields(botCode, senderId) {
        return $http.get(`/live-support/customer-info/${botCode}/${senderId}/`)
    },
    getSenderFavoriteTags(botCode, senderId, startDate, endDate, limit) {
        /*
        TO GET FAVORITE TAGS:
        call api with an empty queries (can set limit query)

        TO GET TAG PER SESSION INFO
        call api with start date & end date (date data same as session info's start date & end date) and set limit if needed

        default limit = 10
     */
        let query = ''
        if (limit && parseInt(limit) > 0) {
            query += '?limit=' + limit
        } else {
            query += '?limit=3'
        }
        if (startDate && typeof startDate === 'string') {
            query += '&from_date=' + startDate
        }
        if (endDate && typeof endDate === 'string') {
            query += '&to_date=' + endDate
        }
        return $http.get('/live-support/' + botCode + '/favorite-tags/' + senderId + query)
    },
    getSenderFavoriteTagsDetails(botCode, tagIDs) {
        // tagIDs = {tags: ["id", "id", ...]}
        return $http.post('/live-support/' + botCode + '/get-all-tags-by-id/', tagIDs)
        // return $http.get('/live-support/' + botCode + '/get-all-tags/')
    },
    updateCustomerBlockStatus(botCode, senderId, block_status, reason) {
        return $http.put(`/live-support/customer-info/${botCode}/${senderId}/update-block-status/`,
            {block_status, reason})
    },
};

export default CustomerService
